<template>
  <cat-alert-marker
    :id="id"
    :type="type"
    :markerText="markerText"
    :offscreenMarkerText="offscreenMarkerText"
    :markerTextClass="markerTextClass"
    :hideMarkerText="hideMarkerText"
  ></cat-alert-marker>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import CatAlertMarker from "@/components/utilities/catAlertMarker.vue";
export default defineComponent({
  name: "CatRepeaterChildMarker",
  components: { CatAlertMarker },
  props: {
    id: {
      type: [String, Number]
    },
    type: {
      type: String,
      description: "Possible values: error, warning, info, debug"
    },
    hideMarkerText: {
      type: Boolean,
      default: false,
      description:
        "Do not show the marker text on screen just the icon. Useful for small spaces."
    },
    markerTextClass: {
      type: String,
      description:
        "Styling to be applied on the marker text. Useful for responsive display. This parameter will override any default marker text styling."
    },
    markerText: {
      type: String,
      default: "Incomplete"
    },
    offscreenMarkerText: {
      type: String,
      default: "Incomplete",
      description:
        "Accessible text to give more context of the text e.g. Director 1 is incomplete."
    }
  }
});
</script>
